import { Serializers, SerializerValue } from "@megaron/serializers";

export const dumpResultSerializer = Serializers.object({
  url: Serializers.string,
  objectName: Serializers.string,
  bucket: Serializers.string,
  service: Serializers.string,
  sizeBytes: Serializers.integer,
  generatedAt: Serializers.datetime,
  rowCounts: Serializers.identity<Record<string, number>>(),
});

export type DumpResult = SerializerValue<typeof dumpResultSerializer>;

export const dumpErrorSerializer = Serializers.stringOneOf("DumpFailed", "DumpAlreadyRunning");

export type DumpError = SerializerValue<typeof dumpErrorSerializer>;
